var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuritySafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.82,
    height: 19.99,
    viewBox: "0 0 17.82 19.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "security-safe",
    d: "M20.91,11.12V6.73a2.4,2.4,0,0,0-1.39-2.06L13.95,2.39a5.187,5.187,0,0,0-3.91,0L4.47,4.67A2.411,2.411,0,0,0,3.09,6.73v4.39a11.524,11.524,0,0,0,8.4,10.81,1.96,1.96,0,0,0,1.02,0A11.524,11.524,0,0,0,20.91,11.12Zm-8.16,1.75V15.5a.75.75,0,0,1-1.5,0V12.87a2.5,2.5,0,1,1,1.5,0Z",
    transform: "translate(-3.09 -2.008)",
    fill: "#f3903a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafe);
export default __webpack_public_path__ + "static/media/security-safe.31f41f84ef4acba24368482fd725d602.svg";
export { ForwardRef as ReactComponent };